import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class WorksStateRequest extends GenericRequest {

    constructor(page, term = '') {
        super(METHOD_GET, ApiEndpoints.WORKS_STATE);
    }

}



// WEBPACK FOOTER //
// ./src/app/works/ws/WorksStatesRequest.js